
// 游戏常量定义
export const POINTS_PER_LEVEL = 2000; // 每关所需分数（固定不变，保证时长一致）
export const REVIVE_COUNTDOWN_START = 3; // 复活倒计时秒数
export const ADV_ROUND = 3;
export const maxRevives = 10;

export const GameConfig = {
  maxRevives:10,
  revives: 10,
  gravity: 0.9,
  jumpStrength: -17,
  baseSpeed: 5,
  speed: 5,
  level: 1,
  score: 0,
  coins: 0,
  coinScore: 100,
  progress: 0,
}

export const GameState = {
  MENU : 'MENU',
  PLAYING : 'PLAYING',
  GAMEOVER : 'GAMEOVER',
  LEVEL_COMPLETE : 'LEVEL_COMPLETE',
  STOP: 'STOP',
}
